// extracted by mini-css-extract-plugin
export default {"modalBtnsWidth":"SwitchNotificationsModal_modalBtnsWidth__rsdnR","modalDescription":"SwitchNotificationsModal_modalDescription__FlM+c"};